import {
  ODSStandardGlobalHeader,
  ODSGlobalHeaderMainNav,
  ODSGlobalHeaderSecondaryNav,
  ODSGlobalHeaderMetaMenu,
  ODSGlobalHeaderMetaLink,
} from '@telekom-ods/react-ui-kit';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import MainNavigation from './MainNavigation';
import IconNavigation from './IconNavigation';

const GlobalHeader = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <ODSStandardGlobalHeader
      style={{ zIndex: 2 }}
      applicationName={intl.formatMessage({ id: 'title' })}
      logoProps={{ href: '/' }}
    >
      <ODSGlobalHeaderSecondaryNav>
        <ODSGlobalHeaderMetaMenu>
          <ODSGlobalHeaderMetaLink
            label={intl.formatMessage({ id: 'documentation' })}
            onClick={() => navigate(`/docs/${import.meta.env.VITE_CONFLUENCE_HOMEPAGE}`)}
          />
        </ODSGlobalHeaderMetaMenu>
      </ODSGlobalHeaderSecondaryNav>
      <ODSGlobalHeaderMainNav>
        <MainNavigation />
        <IconNavigation />
      </ODSGlobalHeaderMainNav>
    </ODSStandardGlobalHeader>
  );
};

export default GlobalHeader;
